var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#366a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "367b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#367b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00421A",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.735 6.372c-.07.636-.266 1.095-.497 1.095s-.427-.459-.496-1.095c-.625-.07-1.075-.27-1.075-.505s.45-.436 1.075-.506c.069-.636.266-1.094.496-1.094s.428.458.497 1.094c.624.07 1.075.271 1.075.506s-.451.435-1.075.505M0 0h6.286v16H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.826 7.432q.03.279.031.567c0 2.65-2.11 4.8-4.714 4.8-2.603 0-4.714-2.15-4.714-4.8s2.11-4.8 4.714-4.8q.283 0 .557.032c-1.793.246-3.176 1.81-3.176 3.702 0 2.061 1.642 3.733 3.667 3.733 1.858 0 3.394-1.408 3.635-3.234",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "366a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagPk = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagPk);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";